var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreMallDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.16 10.8968C23.07 10.4368 22.66 10.0968 22.18 10.0968H7.82C7.34 10.0968 6.93 10.4368 6.84 10.8968L6 15.0968V16.0968C6 16.6468 6.45 17.0968 7 17.0968V22.0968C7 22.6468 7.45 23.0968 8 23.0968H16C16.55 23.0968 17 22.6468 17 22.0968V17.0968H21V22.0968C21 22.6468 21.45 23.0968 22 23.0968C22.55 23.0968 23 22.6468 23 22.0968V17.0968C23.55 17.0968 24 16.6468 24 16.0968V15.0968L23.16 10.8968ZM15 21.0968H9V17.0968H15V21.0968ZM8 9.0968H22C22.55 9.0968 23 8.6468 23 8.0968C23 7.5468 22.55 7.0968 22 7.0968H8C7.45 7.0968 7 7.5468 7 8.0968C7 8.6468 7.45 9.0968 8 9.0968Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreMallDirectory);
export default __webpack_public_path__ + "static/media/store_mall_directory.81c628e4d86fc88b0cc733797bc43545.svg";
export { ForwardRef as ReactComponent };